var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"check-box",attrs:{"hide-details":"","color":"#74B8BE"},on:{"change":_vm.changeAction},model:{value:(_vm.inputIsChecked),callback:function ($$v) {_vm.inputIsChecked=$$v},expression:"inputIsChecked"}})}
var staticRenderFns = []

export { render, staticRenderFns }